import { AuthProvider, useAuth, WebSocketProvider } from '@app:providers';
import { useStore } from '@app:store';
import { Frame } from 'components/@common/layout';
import React from 'react';

import { Route, Routes, useNavigate } from 'react-router-dom';

import { ProductionViews, ResourceViews, SettingsViews } from './views';

function App() {
  const [store, dispatch] = useStore();

  const websocketUri = React.useMemo(() => {
    if (!store.authentication.token) return '';

    const url = new URL('/api/dispatch/ws/users', process.env.REACT_APP_API_HOST);
    url.protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    url.searchParams.set('token', store.authentication.token);
    return url;
  }, [store.authentication.token]);

  return (
    <AuthProvider>
      <WebSocketProvider
        uri={websocketUri.toString()}
        maxRetries={5}
        autoConnect={store.authentication.token !== null}
        onMessage={(event, payload) => {
          dispatch('location', 'processMessage', { type: event, payload }, undefined, () => {
            console.error('Failed to process Websocket message');
          });
        }}
      >
        <AppRouting />
      </WebSocketProvider>
    </AuthProvider>
  );
}

function AppRouting() {
  return (
    <Frame sidebarVisible={true}>
      <Routes>
        <Route path='/' element={<ProductionViews.ProductionTimeline />} />
        <Route path='/devices' element={<ProductionViews.ProductionTimeline />} />
        <Route path='/orders' element={<ProductionViews.ProductionOrders />} />
        <Route path='/resources' element={<ResourceViews.Manager />} />
        <Route path='/resources/:materialId' element={<ResourceViews.MaterialDetail />} />
        <Route path='/settings' element={<SettingsViews.Settings />} />
        <Route path='/signout' element={<Signout />} />
      </Routes>
    </Frame>
  );
}

const Signout = () => {
  const { signout } = useAuth();
  const navigate = useNavigate();
  React.useEffect(() => {
    signout()
      .then(() => {
        navigate('/');
      })
      .catch(() => {
        navigate('/');
      });
  }, []);

  return null;
};

export default App;
